import { PenSquare } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PageHeader } from "@/components/Layout/PageHeader";
import { PostManager } from "./PostManager";
import { PostsList } from "./PostsList";

export function PostsPage() {
  return (
    <div>
      <PageHeader
        icon={PenSquare}
        title="Create & Manage Posts"
        description="Compose new social media posts, schedule content across platforms, and review your publishing history. Posts can be sent for approval before going live."
      />
      <Tabs defaultValue="create" className="space-y-6">
        <TabsList>
          <TabsTrigger value="create">Create Post</TabsTrigger>
          <TabsTrigger value="my-posts">My Posts</TabsTrigger>
        </TabsList>
        <TabsContent value="create">
          <PostManager />
        </TabsContent>
        <TabsContent value="my-posts">
          <PostsList />
        </TabsContent>
      </Tabs>
    </div>
  );
}
